import { render } from "./SettingsToggleTable.vue?vue&type=template&id=454d840c&scoped=true"
import script from "./SettingsToggleTable.vue?vue&type=script&lang=js"
export * from "./SettingsToggleTable.vue?vue&type=script&lang=js"

import "./SettingsToggleTable.vue?vue&type=style&index=0&id=454d840c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454d840c"]])

export default __exports__